<template>
  <div class="user">
    <component-loader :progress="90" :unlimitedProgress="true" v-if="!userDetail"></component-loader>
    <div class="infos">
      
      <img class="image-user" v-if="page && page.network == 'linkedin' && user && user.logoV2" :src="user.logoV2" :alt="user.localizedName"/>
      <img class="image-user" :alt="user.name || user.username" :src="user.picture.data.url" v-else-if="user.picture"/>
      <img class="image-user" :alt="user.name" :src="user.avatar" v-else-if="user.avatar"/>
      <img class="image-user" src="img/avatar.jpg" v-else/>
  
      <div class="container-name">
    
        <div class="name">
          <Tooltip v-if="user.block" :text="$t('dash.inbox.user.blocked')">
            <i class="fa-solid fa-lock"></i>
          </Tooltip>

          <a :href="userLink" target="_blank">
            {{ user.name || user.username || user.localizedName || "Aucun résultat" }}   
          </a>
          <div class="more">
            <ContextMenu :options="getOptionContextMenu" :id="'blockUser'" v-on:clickOption="clickOptionUser">
                <i class="fa-solid fa-ellipsis-vertical"></i>
            </ContextMenu>
          </div>
          <!-- <div class="more">
            <vs-dropdown vs-custom-content vs-trigger-click color="#B20564">
              <a class="a-icon" href.prevent>
                <i class="material-icons">more_vert</i>
              </a>
              <vs-dropdown-menu class="more-user-inbox">
                <vs-dropdown-item @click="getActivities">{{ $t('dash.inbox.user.show_activities') }}</vs-dropdown-item>
                <vs-dropdown-item @click="blockUser" v-if="!user.block && page.network != 'instagram'">{{ $t('dash.inbox.user.block') }}</vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div> -->
        </div>
        <!-- <div class="stars">
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-regular fa-star"></i>
          <i class="fa-regular fa-star"></i>
        </div> -->
      </div>

      <div class="container-count">
        <!-- <div class="count-notes">
          <span>{{ userDetail && userDetail._source && userDetail._source.notes && userDetail._source.notes.length ? userDetail._source.notes.length : 0 }}</span> {{ userDetail && userDetail._source && userDetail._source.notes && userDetail._source.notes.length > 1 ? $t('dash.inbox.user.count_notes') : $t('dash.inbox.user.count_note') }}
        </div> -->
        <div class="count-activities" @click="getActivities">
          <span>{{ userDetail && userDetail.count_activities ? userDetail.count_activities : 0 }}</span> {{ userDetail && userDetail.count_activities > 1 ? $t('dash.inbox.user.count_activities') : $t('dash.inbox.user.count_activity') }}
        </div>
      </div>
      
      <div class="expand" @click="showDetails = !showDetails">
        <i class="fa-solid fa-chevron-right" :class="{open : showDetails}"></i>
      </div>

    </div>
    <div class="details" v-if="showDetails">
      <div class="title">{{ $t('dash.inbox.user.personal_data') }}</div>
      <div class="user-infos">

        <div class="email">
          <div class="left">
            <i class="fa-solid fa-envelope"></i>
          </div>
          <div class="right">
            <div class="title">{{ $t('dash.inbox.user.email.title') }}</div>
            <div class="list">
              <ul v-if="userDetail._source">
                <li v-for="(email, key) in userDetail._source.emails" :key="key">
                  {{ email }}
                  <i class="fa-solid fa-pen"></i>
                  <i class="fa-regular fa-trash-can"></i>
                </li>
              </ul>
              <div class="add-email" v-if="!showAddEmail" @click="showInput('email')">{{ $t('dash.inbox.user.add_email') }}</div>
              <div class="container-input" v-if="showAddEmail">
                <input  ref="inputTitle"  v-model="emailToAdd" v-on:keyup.enter="addEmail" v-on:blur="hideInput" :placeholder="$t('dash.inbox.user.email_placeholder')" type="text" name="email"/>
                <i class="fa-solid fa-check" @click.stop="addEmail"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="phone">
          <div class="left">
            <i class="fa-solid fa-phone"></i>
          </div>
          <div class="right">
            <div class="title">{{ $t('dash.inbox.user.phone.title') }}</div>
            <div class="list">
              <ul v-if="userDetail._source">
                <li v-for="(phone, key) in userDetail._source.phones" :key="key">
                  {{ phone }}
                  <i class="fa-solid fa-pen"></i>
                  <i class="fa-regular fa-trash-can"></i>
                </li>
              </ul>
              <div class="add-phone" v-if="!showAddPhone" @click="showInput('phone')">{{ $t('dash.inbox.user.add_phone') }}</div>
              <div class="container-input" v-if="showAddPhone">
                <input  ref="inputTitle"  v-model="phoneToAdd" v-on:keyup.enter="addPhone" v-on:blur="hideInput" :placeholder="$t('dash.inbox.user.phone_placeholder')" type="text" name="phone"/>
                <i class="fa-solid fa-check" @click.stop="addPhone"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="url">
          <div class="left">
            <i class="fa-solid fa-link"></i>
          </div>
          <div class="right">
            <div class="title">{{ $t('dash.inbox.user.url.title') }}</div>
            <div class="list">
              <ul v-if="userDetail._source">
                <li v-for="(url, key) in userDetail._source.urls" :key="key">
                  {{ url }}
                  <i class="fa-solid fa-pen"></i>
                  <i class="fa-regular fa-trash-can"></i>
                </li>
              </ul>
              <div class="add-url" v-if="!showAddUrl" @click="showInput('url')">{{ $t('dash.inbox.user.add_url') }}</div>
              <div class="container-input" v-if="showAddUrl">
                <input  ref="inputTitle" v-model="urlToAdd" v-on:keyup.enter="addUrl" v-on:blur="hideInput" :placeholder="$t('dash.inbox.user.url_placeholder')" type="text" name="url"/>
                <i class="fa-solid fa-check" @click.stop="addUrl"></i>
                
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="phone">
          <div class="title"><span class="material-icons">phone</span> {{ $t('dash.inbox.user.phone.title') }}</div>
          <div class="list">
            <ul v-if="userDetail._source">
              <li v-for="(phone, key) in userDetail._source.phones" :key="key">{{ phone }}</li>
            </ul>
            <div class="add-phone" v-if="!showAddPhone" @click="showInput('phone')">{{ $t('dash.inbox.user.add_phone') }}</div>
            <vs-input
              v-if="showAddPhone"
              v-validate="'required'"
              :class="{'input': true }"
              vs-size="large"
              color="#B20564"
              type="text"
              name="phone"
              class="inputx"
              :placeholder="$t('dash.inbox.user.phone_placeholder')"
              v-model="phoneToAdd"
              ref="inputTitle"
              @keyup.enter.native="addPhone"
            />
          </div>
        </div>
        <div class="url">
          <div class="title"><span class="material-icons">link</span> {{ $t('dash.inbox.user.url.title') }}</div>
          <div class="list">
            <ul v-if="userDetail._source">
              <li v-for="(url, key) in userDetail._source.urls" :key="key">{{ url }}</li>
            </ul>
            <div class="add-url" v-if="!showAddUrl" @click="showInput('url')">{{ $t('dash.inbox.user.add_url') }}</div>
            <vs-input
              v-if="showAddUrl"
              v-validate="'required'"
              :class="{'input': true }"
              vs-size="large"
              color="#B20564"
              type="text"
              name="url"
              class="inputx"
              :placeholder="$t('dash.inbox.user.url_placeholder')"
              v-model="urlToAdd"
              ref="inputTitle"
              @keyup.enter.native="addUrl"
            />
          </div>
        </div> -->
      </div>

      <div class="container-title">
        <p class="title">{{ $t('dash.inbox.user.notes.title') }} </p>
        <div v-if="!showAddNote" class="add" @click="showInput('note')"><i class="fa-regular fa-note"></i>Ajouter une note</div>
        <div  v-else class="add" @click="addNote"><i class="fa-solid fa-check"></i>Ajouter la  note</div>
      </div>
      <div class="notes">
        <ul v-if="userDetail._source">
          <li :key="'addNote'" v-if="showAddNote">
            
            <img class="image-user" :src="localStorage && localStorage.user && JSON.parse(localStorage.user).avatar ? JSON.parse(localStorage.user).avatar : 'img/avatar.jpg' "/>
           
            <div class="container-message">
              <div class="message">
          
                <textarea  :placeholder="$t('dash.inbox.user.note_placeholder')" name="note" class="textarea-add" v-model="noteToAdd" ref="inputTitle">
                
                </textarea>
              </div>

              <div class="more">
                <div class="date">
                 
                </div>
                <i class="fa-solid fa-xmark" @click="hideInput"></i>
                <i class="fa-solid fa-check" @click="addNote"></i>
              </div>
            </div>
          </li>

          <li v-for="(note, key) in userDetail._source.notes" :key="key">
            
            <img class="image-user" :alt="`${JSON.parse(note).user.firstname} ${JSON.parse(note).user.lastname}`" :src="JSON.parse(note).user.avatar"/>
           
            <div class="container-message">
              <div class="message">
                <p>{{ JSON.parse(note).message}}</p>

                <textarea v-if="note.isEdit" :value="JSON.parse(note).message" class="textarea-edit">
                
                </textarea>
              </div>

              <div class="more">
                <div class="date">
                  {{ `${$t('dash.inbox.user.note.created_by')} ${JSON.parse(note).user.firstname} ${JSON.parse(note).user.lastname} ${$t('dash.inbox.user.note.the')} ${formatDate(JSON.parse(note).date)} ${$t('dash.inbox.user.note.at')} ${formatHour(JSON.parse(note).date)}` }} 
                </div>
                <i class="fa-solid fa-pen"></i>
                <i class="fa-regular fa-trash-can"></i>
              </div>
            </div>
          </li>
        </ul>
      </div>

    </div>
  </div>
  
</template>

<script>
import moment from 'moment'
import Moderation from './../../mixins/Moderation'
import Notif from './../../mixins/Notif'
import Tooltip from './../tooltip/tooltipInit'
import PageImageAvatar from './../PageImageAvatar'
import componentLoader from './../overlay/Loader'
import ContextMenu from './../contextMenu/contextMenuInit.vue'

export default {
  name: 'component-user-inbox',

  mixins: [Moderation, Notif],

  components: {
    Tooltip,
    PageImageAvatar,
    componentLoader,
    ContextMenu
  },

  props: {
    page: Object,
    user: Object
  },

  data() {
    return {
      userDetail: null,

      showDetails: false,

      showAddEmail: false,
      emailToAdd: null,

      showAddPhone: false,
      phoneToAdd: null,

      showAddUrl: false,
      urlToAdd: null,

      showAddNote: true,
      noteToAdd: null,
    }
  },
  computed: {
    userLink() {
      if(this.user && this.user.link) return this.user.link
      if(this.page && this.page.network == 'tiktok' && this.user && this.user.unique_id)
        return `https://www.tiktok.com/@${this.user.unique_id}`
      return null
    },

    getOptionContextMenu() {
      let options = [{label: this.$t('dash.inbox.user.show_activities'), name : 'viewActivity'}]
      if(this.user && !this.user.block && this.page && ['facebook', 'tiktok'].includes(this.page.network)) {
        options.push({label: this.$t('dash.inbox.user.block'), name : 'blockUser'})
      }
      return options
    }
  },
  async mounted() {
    await this.getUser()
  },

  methods: {

    formatDate(date) {
      return moment(date).locale(this.$i18n.locale || navigator.language).format('DD MMMM YYYY').toString() 
    },

    formatHour(date) {
      return moment(date).locale(this.$i18n.locale || navigator.language).format('HH:mm').toString() 
    },

    async blockUser(){
      let updateUser = await this.updateInboxUser(this.page, this.user, { 
        name: this.user.name, 
        picture: this.user.picture,
        link: this.user.link
      })
      
      if(updateUser && updateUser.body.success && updateUser.body.user){
        let status = await this.blockUserComment(this.page, this.user.id || this.user.userId, this.user.sec_uid, this.user.unique_id)
        console.log('blockUser', status)
        if(status && status.body && status.body.success && status.body.block){
          this.updateInboxUser(this.page, this.user, { block: status.body.block }).then(res => {
            console.log('resss user', res)
            this.showLoader = false
            const { success, error } = res.body
  
            if (!success || success !== true) {
              return
            }
  
            this.userDetail = res.body.user
          })
          this.$emit('refreshEvents')
        }
        else {
          this.notify({
            title:this.$t('dash.moderation.notification.error'),
            text:this.$t('dash.inbox.user.block.failed'),
            color:'primary',
            time: 4000,
            id: this.page.id
          }, {
            component: "Inbox",
            action: "block user",
            params: {
              page: this.page.name,
              network: this.page.network,
              user: this.user.name,
              id: this.user.id || this.user.userId
            }
          })
          return
        }
      }
    },

    getActivities(){
      this.$emit('getActivities', this.user)
    },
    
    async getUser(){
      this.showLoader = true

      this.getInboxUser(this.page, this.user).then(res => {
        console.log('resss user', res)
        this.showLoader = false
        const { success, error } = res.body

        if (!success || success !== true) {
          return
        }

        this.userDetail = res.body.user
      })
    },

    showInput(type) {
      this.showAddEmail = false
      this.showAddPhone = false
      this.showAddUrl = false
      this.showAddNote = false
      switch(type) {
        case 'email' : 
          this.showAddEmail = true
          break
        case 'phone' : 
          this.showAddPhone = true
          break
        case 'url' : 
          this.showAddUrl = true
          break
        case 'note':
          this.showAddNote = true
          break
      }
      
    },

    hideInput() {
      this.showAddEmail = false
      this.showAddPhone = false
      this.showAddUrl = false
      this.showAddNote = false
      this.emailToAdd = null
      this.phoneToAdd = null
      this.urlToAdd = null
      this.noteToAdd = null
    },

    clickOptionUser(id, nameOption){
      switch (nameOption) {
        case "blockUser": {
          this.blockUser()
          break;
        }
          
   
        case "viewActivity": {
          this.getActivities()
          break;
        }
      }
    },

    async addEmail() {
      if(this.emailToAdd && this.emailToAdd != '') { // add regex to check email
        this.showLoader = true
        let emails = this.userDetail.emails ? this.userDetail.emails : []
        emails.push(this.emailToAdd)
        this.updateInboxUser(this.page, this.user, { emails }).then(res => {
          console.log('resss user', res)
          this.showLoader = false
          const { success, error } = res.body

          if (!success || success !== true) {
            return
          }

          this.userDetail = res.body.user
          this.showAddEmail = false
          this.emailToAdd = null
        })
      }
    },

    async addPhone() {
      console.log('addPhone',this.phoneToAdd)
      if(this.phoneToAdd && this.phoneToAdd != '') { // add regex to check phone
        this.showLoader = true
        let phones = this.userDetail.phones ? this.userDetail.phones : []
        phones.push(this.phoneToAdd)
        this.updateInboxUser(this.page, this.user, { phones }).then(res => {
          console.log('resss user', res)
          this.showLoader = false
          const { success, error } = res.body

          if (!success || success !== true) {
            return
          }

          this.userDetail = res.body.user
          this.showAddPhone = false
          this.phoneToAdd = null
        })
      }
    },

    async addUrl() {
  
      if(this.urlToAdd && this.urlToAdd != '') { // add regex to check url
        this.showLoader = true
        let urls = this.userDetail.urls ? this.userDetail.urls : []
        urls.push(this.urlToAdd)
        this.updateInboxUser(this.page, this.user, { urls }).then(res => {
          console.log('resss user', res)
          this.showLoader = false
          const { success, error } = res.body

          if (!success || success !== true) {
            return
          }

          this.userDetail = res.body.user
          this.showAddUrl = false
          this.urlToAdd = null
        })
      }
    },

    async addNote() {
      if(this.noteToAdd && this.noteToAdd != '') { // add regex to check url
        this.showLoader = true
        let notes = this.userDetail.notes ? this.userDetail.notes : []
        // notes.push(this.noteToAdd)
        notes.push(JSON.stringify({
          message: this.noteToAdd,
          user: JSON.parse(localStorage.user),
          date: moment().format()
        }))
        this.updateInboxUser(this.page, this.user, { notes }).then(res => {
          console.log('resss user', res)
          this.showLoader = false
          const { success, error } = res.body

          if (!success || success !== true) {
            return
          }

          this.userDetail = res.body.user
          this.showAddNote = false
          this.noteToAdd = null
        })
      }
    },
  
  },

  watch: {
    async user() {
      this.userDetail = null
      this.showDetails = false
      this.showAddEmail = false
      this.showAddPhone = false
      this.showAddUrl = false
      this.showAddNote = false

      await this.getUser()
    }
  }

}    
</script>
